<template>
    <div class="field col-12 mb-3 mt-4">
        <div class="d-flex w-100 justify-content-between align-items-center mb-3">
            <h5 class="m-0 font-weight-500" style="font-size: 1.1rem;">{{ t('plans-form-discount_table-title') }}</h5>
            <button class="btn btn-outline-secondary btn-sm" @click.prevent="addDiscount">
                {{ t('plans-form-discount_table-add_button') }}
            </button>
        </div>

        <div class="border rounded p-3 mb-3 bg-white" v-for="(discount, index) in localValue" :key="index" style="border-color: #dee2e6;">
            <div class="d-flex w-100 justify-content-between align-items-center mb-3">
                <span class="text-primary font-weight-500" style="color: #6C81A1 !important;">{{ t('plans-form-discount_table-discount_index', { 0: index + 1 }) }}</span>
                <i class="mdi mdi-delete-outline text-secondary" style="font-size: 1.2rem; cursor: pointer;" @click="removeDiscount(index)"></i>
            </div>
            
            <div class="row">
                <div class="col-md-4 mb-3">
                    <label>{{ t('plans-form-discount_table-value') }}</label>
                    <div class="input-group">
                        <input type="number" step="0.01" class="form-control" v-model="discount.value" placeholder="0,00" @input="updateValue" />
                        <div class="input-group-append">
                            <select class="form-control" style="background-color: #f8f9fa; border-left: none;" v-model="discount.type" @change="updateValue">
                                <option value="currency">{{ currency === 'USD' ? '$ USD' : '$ R$' }}</option>
                                <option value="percentage">%</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 mb-3">
                    <label>{{ t('plans-form-discount_table-start_date') }}</label>
                    <input type="date" class="form-control" v-model="discount.start_date" @input="updateValue" />
                </div>
                <div class="col-md-4 mb-3">
                    <label>{{ t('plans-form-discount_table-end_date') }}</label>
                    <input type="date" class="form-control" v-model="discount.end_date" @input="updateValue" />
                </div>
                
                <div class="col-12">
                    <label>{{ t('plans-form-discount_table-description') }}</label>
                    <textarea class="form-control" v-model="discount.description" :placeholder="t('plans-form-discount_table-description_placeholder')" rows="2" @input="updateValue"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        currency: {
            type: String,
            default: "BRL"
        }
    },
    data() {
        return {
            localValue: []
        };
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(this.localValue)) {
                    this.localValue = JSON.parse(JSON.stringify(newVal || []));
                }
            }
        }
    },
    methods: {
        addDiscount() {
            this.localValue.push({
                value: null,
                type: 'currency',
                start_date: null,
                end_date: null,
                description: null
            });
            this.updateValue();
        },
        removeDiscount(index) {
            this.localValue.splice(index, 1);
            this.updateValue();
        },
        updateValue() {
            this.$emit("input", this.localValue);
        },
        t(term, replaces) {
            return this.$root.t ? this.$root.t(term, replaces) : term;
        }
    }
};
</script>
